// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared spinner sizing and alignment for the application. */
.loading-indicator {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  color: #475569;
}

.loading-indicator--centered {
  display: flex;
  justify-content: center;
  width: 100%;
}

.loading-indicator--sm .spinner-border {
  width: 1rem;
  height: 1rem;
}

.loading-indicator--md .spinner-border {
  width: 2rem;
  height: 2rem;
}

.loading-indicator--lg .spinner-border {
  width: 3rem;
  height: 3rem;
}

.loading-indicator__message {
  font-size: 0.95rem;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/modules/app-common/components/loading-indicator/loading-indicator.component.scss"],"names":[],"mappings":"AAAA,6DAAA;AACA;EACI,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AACJ;;AAEA;EACI,aAAA;EACA,uBAAA;EACA,WAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;AACJ;;AAEA;EACI,kBAAA;EACA,gBAAA;AACJ","sourcesContent":["/* Shared spinner sizing and alignment for the application. */\n.loading-indicator {\n    display: inline-flex;\n    align-items: center;\n    gap: 12px;\n    color: #475569;\n}\n\n.loading-indicator--centered {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n}\n\n.loading-indicator--sm .spinner-border {\n    width: 1rem;\n    height: 1rem;\n}\n\n.loading-indicator--md .spinner-border {\n    width: 2rem;\n    height: 2rem;\n}\n\n.loading-indicator--lg .spinner-border {\n    width: 3rem;\n    height: 3rem;\n}\n\n.loading-indicator__message {\n    font-size: 0.95rem;\n    font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
